module.exports = __webpack_public_path__ + "static/media/tiet-kiem-nang-luong-active.59120afd.svg";